import { useSession } from "../../lib/session";
import { Button, Card } from "../../components/ui";

/**
 * Shown to an authenticated user whose profile is not yet approved
 * (is_active = false, the default for every new sign-in) or has been
 * deactivated. Purely cosmetic: RLS already returns nothing for them —
 * this screen just says so politely instead of rendering empty pages.
 */
export default function PendingApproval() {
  const { session, signOut } = useSession();
  const email = session?.user.email ?? "your account";

  return (
    <div style={{ display: "grid", placeItems: "center", minHeight: "100dvh", padding: 16 }}>
      <div style={{ width: "min(440px, 100%)" }}>
        <div className="brand" style={{ justifyContent: "center", fontSize: "1.15rem" }}>
          <img className="brand-mark" src="/icon-48.png" alt="" aria-hidden="true" />
          Viewpoint Core
        </div>

        <Card title="Awaiting approval">
          <p style={{ marginBottom: 10 }}>
            You have signed in as <strong>{email}</strong>, but this account has not
            been approved for access yet.
          </p>
          <p className="muted small" style={{ marginBottom: 14 }}>
            An administrator needs to activate your profile and assign you a role.
            Until then the application holds no data for you.
          </p>
          <Button block onClick={() => void signOut()}>
            Sign out
          </Button>
        </Card>
      </div>
    </div>
  );
}
